// src/components/Reviews/Reviews.jsx
import React, { useState, useEffect } from 'react';
import styles from './Reviews.module.css';

const Reviews = () => {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        loadReviews();
    }, []);

    const loadReviews = async () => {
        try {
            const response = await fetch('/api/external-reviews');
            const data = await response.json();
            setReviews(data);
        } catch (error) {
            console.error('Ошибка загрузки отзывов:', error);
        } finally {
            setLoading(false);
        }
    };

    // Автоматическое переключение
    useEffect(() => {
        if (reviews.length === 0) return;
        const interval = setInterval(() => {
            setActiveIndex(prev => (prev + 1) % reviews.length);
        }, 8000);
        return () => clearInterval(interval);
    }, [reviews.length]);

    if (loading || reviews.length === 0) return null;

    const renderStars = (rating) => {
        return '★'.repeat(rating) + '☆'.repeat(5 - rating);
    };

    return (
        <section className={styles.reviews}>
            <div className={styles.container}>
                <h2 className={styles.title}>ОТЗЫВЫ</h2>
                <div className={styles.subtitle}>Что говорят клиенты</div>

                <div className={styles.reviewsSlider}>
                    <button
                        className={styles.navBtn}
                        onClick={() => setActiveIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1))}
                    >
                        ⟨
                    </button>

                    <div className={styles.reviewsContainer}>
                        <div className={styles.reviewCard}>
                            <div className={styles.reviewHeader}>
                                <div className={styles.reviewMeta}>
                                    <h3 className={styles.reviewName}>{reviews[activeIndex].author_name}</h3>
                                    <div className={styles.stars}>{renderStars(reviews[activeIndex].rating)}</div>
                                    <span className={styles.reviewDate}>
                                        {new Date(reviews[activeIndex].date).toLocaleDateString('ru-RU')}
                                    </span>
                                </div>
                            </div>
                            <div className={styles.reviewContent}>
                                <p className={styles.reviewText}>{reviews[activeIndex].text}</p>
                            </div>
                        </div>
                    </div>

                    <button
                        className={styles.navBtn}
                        onClick={() => setActiveIndex((prev) => (prev + 1) % reviews.length)}
                    >
                        ⟩
                    </button>
                </div>

                <div className={styles.dots}>
                    {reviews.map((_, idx) => (
                        <button
                            key={idx}
                            className={`${styles.dot} ${idx === activeIndex ? styles.activeDot : ''}`}
                            onClick={() => setActiveIndex(idx)}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Reviews;